module.exports = __webpack_public_path__ + "assets/favicon-devel-44c675.ico";